import { bizmatesApi, bizmatesWordbookApi } from '@/utils/bizmatesApi';
import qs from 'qs';

export default {
  namespaced: true,
  state() {
    return {
      categoryLists: null,
      categorizedWords: null,
      menuItemPerPage: 50,
      modalItemPerPage: 50,
      modalCategorizedWords: null,
      modalCategoryId: 0,
      listCategoryId: 0,
      selectAll: false,
      selectedWords: [],
      isIndeterminate: false,
      enabledDragStyle: true,
      wordsForDeletion: null,
      wordsMovedToCategory: null,
      categoryCreatedId: 0,
      categoryUpdatedId: 0,
      categoryDeleted: null,
      categorySorted: false,
      categoryWordsDeleted: null,
      isTranslationListEdit: false,
      translationListEdited: {
        isCancel: false,
      },
      translatedWord: null,
      translation: null,
    };
  },
  mutations: {
    setCategoryLists(state, payload) {
      state.categoryLists = payload;
    },
    setCategorizedWords(state, payload) {
      state.categorizedWords = payload;
    },
    setModalCategorizedWords(state, payload) {
      state.modalCategorizedWords = payload;
    },
    setModalCategoryId(state, payload) {
      state.modalCategoryId = payload;
    },
    setSelectedWords(state, payload) {
      state.selectedWords = payload;
    },
    setIsIndeterminate(state, payload) {
      state.isIndeterminate = payload;
    },
    setSelectAll(state, payload) {
      state.selectAll = payload;
    },
    setEnabledDragStyle(state, payload) {
      state.enabledDragStyle = payload;
    },
    setCategoryCreated(state, payload) {
      state.categoryCreatedId = payload;
    },
    setCategoryUpdated(state, payload) {
      state.categoryUpdatedId = payload;
    },
    setCategoryDeleted(state, payload) {
      state.categoryDeleted = payload;
    },
    setWordsForDeletion(state, payload) {
      state.wordsForDeletion = payload;
    },
    setListCategoryId(state, payload) {
      state.listCategoryId = payload;
    },
    setMenuItemPerPage(state, payload) {
      state.menuItemPerPage = payload;
    },
    setModalItemPerPage(state, payload) {
      state.modalItemPerPage = payload;
    },
    setCategorySorted(state, payload) {
      state.categorySorted = payload;
    },
    setCategoryWordsDeleted(state, payload) {
      const data = { items: payload, affected_rows_words: payload.length - 1 };
      state.categoryWordsDeleted = data;
    },
    setIsTranslationListEdit(state, payload) {
      state.isTranslationListEdit = payload;
    },
    setTranslationListEdited(state, payload) {
      state.translationListEdited = payload;
    },
    setWordsMovedToCategory(state, payload) {
      state.wordsMovedToCategory = payload;
    },
    setTranslatedWord(state, payload) {
      state.translatedWord = payload;
    },
    setTranslation(state, payload) {
      state.translation = payload;
    },
  },
  actions: {
    async getCategoryLists({ commit }) {
      await bizmatesApi.get('vocabulary/category_list', {}, response => {
        if (response.data !== undefined && Object.keys(response.data).length > 0) {
          commit('setCategoryLists', response.data);
        }
      });
    },
    async getMenuCategorizedWords({ commit }, params) {
      await bizmatesApi.get('vocabulary/categorized_words', { params }, response => {
        if (response.data !== undefined && Object.keys(response.data).length > 0) {
          commit('setCategorizedWords', response.data.result);
        }
      });
    },
    async getModalCategorizedWords({ commit }, params) {
      await bizmatesApi.get('vocabulary/categorized_words', { params }, response => {
        if (response.data !== undefined && Object.keys(response.data).length > 0) {
          if (this.state.layout.isVocabularyDeleteVisible) {
            commit('setWordsForDeletion', response.data.result);
          } else if (this.state.layout.isVocabularyVisible) {
            commit('setModalCategorizedWords', response.data.result);
          }
        }
      });
    },
    async createCategoryName({ commit }, params) {
      await bizmatesApi.post('vocabulary/insert_category', qs.stringify(params), {}, response => {
        commit('setCategoryCreated', response.data.data.id);
      });
    },
    async updateCategoryName({ commit }, params) {
      await bizmatesApi.post('vocabulary/update_category', qs.stringify(params), {}, response => {
        commit('setCategoryUpdated', response.data.data.affected_rows);
      });
    },
    async deleteWordsByCategory({ commit }, params) {
      await bizmatesApi.delete('vocabulary/category', params, response => {
        commit('setCategoryDeleted', response.data.data);
      });
    },
    async updateSortCategory({ commit }, params) {
      await bizmatesApi.post('vocabulary/sort_category', params, {}, response => {
        commit('setCategorySorted', response.data.status);
      });
    },
    async moveWordsToCategory({ commit }, params) {
      await bizmatesApi.put('vocabulary/move_words', params, {}, response => {
        commit('setWordsMovedToCategory', { ...response.data, ...params });
      });
    },
    async deleteCategoryWords({ commit }, params) {
      await bizmatesApi.deleteBodyRequest('vocabulary/translation', params, response => {
        commit('setCategoryWordsDeleted', JSON.parse(response.config.data));
      });
    },
    async updateTranslationList({ commit }, params) {
      await bizmatesApi.post('vocabulary/update', params, {}, response => {
        commit('setTranslationListEdited', { ...response.data, isCancel: false });
      });
    },
    async translateWord({ commit }, params) {
      await bizmatesApi.post('vocabulary/translation', qs.stringify(params), {}, response => {
        commit('setTranslatedWord', response.data);
      });
    },
    async saveTranslation({ commit }, params) {
      await bizmatesApi.post('vocabulary/store', qs.stringify(params), {}, response => {
        commit('setTranslation', { ...params, id: response.data.result });
      });
    },
    async setAsImportant(context, params) {
      await bizmatesWordbookApi.post('word/important', qs.stringify(params), err => err);
    },
    async updateNote(context, params) {
      await bizmatesWordbookApi.put('word/note', qs.stringify(params), err => err);
    },
    resetSelectedWords({ commit }) {
      commit('setSelectedWords', []);
      commit('setIsIndeterminate', false);
      commit('setSelectAll', false);
    },
  },
};
